(() => {
  const parents = '.mw-apo-container';
  const pendingSelections = new WeakMap();
  let scheduled = false;

  function careKind(control) {
    const text = (control.closest('label')?.textContent || control.getAttribute('data-identifier') || '').toLowerCase();
    const cleaner = /anti[\s-]*static.*(?:cleaner|polish)/.test(text);
    const cloth = /microfibre|microfiber|(?:cleaning|polishing) cloth/.test(text);
    if (cleaner === cloth) return '';
    return cleaner ? 'cleaner' : 'cloth';
  }

  function universalRow(root) {
    return root.querySelector('[data-option-id="o_3568052"], .pp-care-shared') || Array.from(root.querySelectorAll('.mw-option')).find(row =>
      (row.querySelector('.mw-text--style-strong')?.textContent || '').trim().toLowerCase() === 'care extras'
    );
  }

  function careControls(row) {
    return new Map(Array.from(row?.querySelectorAll('input[type="checkbox"]') || [])
      .map(control => [careKind(control), control]).filter(([kind]) => kind));
  }

  function setHidden(element, className, hidden) {
    if (element.classList.contains(className) !== hidden) element.classList.toggle(className, hidden);
  }

  function sync(root) {
    const shared = universalRow(root);
    if (shared) shared.classList.add('pp-care-shared');
    const nativeControls = careControls(root.querySelector('#calculator'));
    const useCalculator = nativeControls.has('cleaner') && nativeControls.has('cloth');
    const controls = useCalculator ? nativeControls : careControls(shared);
    if (shared) setHidden(shared, 'pp-care-native', useCalculator);
    nativeControls.forEach(control => {
      if (!control.hasAttribute('aria-label')) control.setAttribute('aria-label', control.getAttribute('data-identifier'));
    });
    if (!controls.has('cleaner') || !controls.has('cloth')) {
      root.querySelectorAll('.pp-care-legacy').forEach(value => setHidden(value, 'pp-care-legacy', false));
      root.querySelectorAll('.pp-care-empty').forEach(row => setHidden(row, 'pp-care-empty', false));
      root.querySelectorAll('.pp-care-container-empty').forEach(parent => setHidden(parent, 'pp-care-container-empty', false));
      return;
    }

    const pending = pendingSelections.get(root) || new Set();
    pendingSelections.set(root, pending);

    root.querySelectorAll('.mw-option').forEach(row => {
      if (row === shared && !useCalculator) return;
      row.querySelectorAll('input[type="checkbox"]').forEach(control => {
        const kind = careKind(control);
        if (!kind) return;
        const value = control.closest('.mw-option__value');
        if (!value) return;
        setHidden(value, 'pp-care-legacy', true);
        if (control.checked) {
          pending.add(kind);
          control.checked = false;
          control.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      const values = Array.from(row.querySelectorAll('.mw-option__value'));
      const empty = values.length > 0 && values.every(value => value.classList.contains('pp-care-legacy'));
      setHidden(row, 'pp-care-empty', empty);
    });

    // Re-query after notifying APO: it can replace option controls on change.
    pending.forEach(kind => {
      const control = (useCalculator ? careControls(root.querySelector('#calculator')) : careControls(universalRow(root))).get(kind);
      if (!control?.isConnected) return;
      if (!control.checked) {
        control.checked = true;
        control.dispatchEvent(new Event('change', { bubbles: true }));
      }
      pending.delete(kind);
    });
    if (!pending.size) pendingSelections.delete(root);
    root.querySelectorAll(parents).forEach(parent => {
      const rows = Array.from(parent.querySelectorAll('.mw-option'));
      setHidden(parent, 'pp-care-container-empty', useCalculator && rows.length > 0 && rows.every(row =>
        row.classList.contains('pp-care-native') || row.classList.contains('pp-care-empty')
      ));
    });
  }

  function syncExtras(parent) {
    const rows = Array.from(parent.children).filter(row => row.matches('.mw-option') &&
      !row.matches('.pp-care-empty, .pp-care-native') &&
      /^(?:care|optional) extras?$/i.test((row.querySelector('.mw-text--style-strong')?.textContent || '').trim())
    );
    parent.querySelectorAll('.pp-extras-row').forEach(row => {
      if (!rows.includes(row)) row.classList.remove('pp-extras-row', 'pp-extras-first', 'pp-extras-last');
    });
    rows.forEach((row, index) => {
      // Keep the original APO rows and controls intact, including their pricing handlers.
      if (index && rows[index - 1].nextElementSibling !== row) {
        parent.insertBefore(row, rows[index - 1].nextElementSibling);
      }
      row.classList.add('pp-extras-row');
      setHidden(row, 'pp-extras-first', index === 0);
      setHidden(row, 'pp-extras-last', index === rows.length - 1);
      row.querySelector(':scope > .mw-stack > .mw-stack__item')?.classList.add('pp-extras-heading');
      const heading = row.querySelector('.mw-text--style-strong');
      if (index === 0 && heading && heading.textContent !== 'Optional extras') heading.textContent = 'Optional extras';
    });
  }

  function scan() {
    scheduled = false;
    const roots = new Set();
    document.querySelectorAll(parents).forEach(parent => roots.add(parent.closest('form') || parent));
    roots.forEach(sync);
    document.querySelectorAll(parents).forEach(syncExtras);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }

  ['input', 'change'].forEach(name => document.addEventListener(name, event => {
    if (event.target.closest?.(parents)) schedule();
  }, true));
  new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.target.closest?.(parents + ', #calculator') || Array.from(mutation.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches(parents + ', #calculator') || node.querySelector(parents + ', #calculator'))
    ))) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('reset', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  scan();
})();

